import { User } from "@/types/database";
import { createContext } from "react";


export interface IContextProps {
    user: User | null;
    loading: boolean;
    error?: string;
    getToken: () => Promise<string | null>;
}

const context = createContext<IContextProps>({
    user: null,
    loading: false,
    getToken: async () => null,
})

export default context;